const ReviewSection = () => {
  const reviews = [
    {
      author: '박**',
      age: 10,
      date: '2024.11.20',
      content: '수학을 싫어하던 아이가 이제는 수업 시간을 기다려요! AI 튜터가 아이 수준에 맞춰서 설명해주니까 이해도 잘 되고 재미있대요. 강력 추천합니다!'
    },
    {
      author: '이**',
      age: 9,
      date: '2024.11.18',
      content: '선생님이 정말 친절하시고, 게임처럼 수학을 배우니까 아이가 너무 좋아해요. 성적도 많이 올랐어요!'
    },
    {
      author: '최**',
      age: 10,
      date: '2024.11.15',
      content: '처음에는 반신반의했는데, 3개월째 듣고 있어요. 아이가 수학 자신감이 생겼다고 하네요. 감사합니다!'
    }
  ]
	return (
		<div className="space-y-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-2xl font-bold text-gray-900">수업 후기</h3>
        <div className="flex items-center space-x-2">
          <span className="text-gray-500">(98개)</span>
        </div>
      </div>

      {reviews?.map((review, index) => (
        <div key={index} className="bg-gray-50 rounded-2xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-purple-200 rounded-full flex items-center justify-center">
                <i className="ri-user-fill text-purple-600 text-xl"></i>
              </div>
              <div>
                <div className="font-bold text-gray-900">{review.author}</div>
                <div className="text-sm text-gray-500">{review.age}세</div>
              </div>
            </div>
            <div className="text-right">
              <div className="text-sm text-gray-500">{review.date}</div>
            </div>
          </div>
          <p className="text-gray-700 leading-relaxed">{review.content}</p>
        </div>
        ))}
    </div>
	);
};

export default ReviewSection;